import clsx from "clsx";
import { FilterPropTypes } from "./propTypes";

const Filter = ({ categories, selectedCategory, setSelectedCategory }) => {

  const handleCategoryClick = (value) => {
    setSelectedCategory(value);
  };

  return (
    <div className="p-px flex flex-col w-fit">
      <div className="flex flex-row flex-wrap justify-start gap-2 max-h-44 overflow-hidden lg:max-h-32">
        {categories.map((item) => (
          <div key={item.name} className={clsx("item-container p-2 bg-darkGrayRevamp rounded-lg", {
            "!bg-watermelon border border-light": selectedCategory === item.name,
          })}>
            <p
              className={clsx("text-light text-sm mb-0 mt-0 cursor-pointer", {
                "pointer-events-none text-light": selectedCategory === item.name,
              })}
              onClick={() => handleCategoryClick(item.name)}
            >
              {item.title}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

Filter.propTypes = FilterPropTypes;

export default Filter;
